module.exports = __webpack_public_path__ + "static/media/sun.e012fdd0.png";